import { render, staticRenderFns } from "./hair.vue?vue&type=template&id=1280828d&scoped=true"
import script from "./hair.vue?vue&type=script&lang=js"
export * from "./hair.vue?vue&type=script&lang=js"
import style0 from "./hair.vue?vue&type=style&index=0&id=1280828d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280828d",
  null
  
)

export default component.exports